import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      isSidebarMinimized: false,
      currentRoleType: 0,
      uploadMediaGuideStep: 'idle' as 'idle' | 'sidebar' | 'add',
      createSessionGuideStep: 'idle' as 'idle' | 'sidebar' | 'add',
      publishSessionGuideStep: 'idle' as 'idle' | 'sidebar' | 'select',
    }
  },

  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized
    },
    setCurrentRoleType(roleType: number) {
      this.currentRoleType = roleType
    },
    startUploadMediaGuide() {
      this.createSessionGuideStep = 'idle'
      this.publishSessionGuideStep = 'idle'
      this.uploadMediaGuideStep = 'sidebar'
      this.isSidebarMinimized = false
    },
    showUploadMediaAddStep() {
      this.uploadMediaGuideStep = 'add'
    },
    finishUploadMediaGuide() {
      this.uploadMediaGuideStep = 'idle'
    },
    startCreateSessionGuide() {
      this.uploadMediaGuideStep = 'idle'
      this.publishSessionGuideStep = 'idle'
      this.createSessionGuideStep = 'sidebar'
      this.isSidebarMinimized = false
    },
    showCreateSessionAddStep() {
      this.createSessionGuideStep = 'add'
    },
    finishCreateSessionGuide() {
      this.createSessionGuideStep = 'idle'
    },
    startPublishSessionGuide() {
      this.uploadMediaGuideStep = 'idle'
      this.createSessionGuideStep = 'idle'
      this.publishSessionGuideStep = 'sidebar'
      this.isSidebarMinimized = false
    },
    showPublishSessionSelectStep() {
      this.publishSessionGuideStep = 'select'
    },
    finishPublishSessionGuide() {
      this.publishSessionGuideStep = 'idle'
    },
  },
})
